var map = {
	"./core-features/burgershot2_cut_compressed.jpg": 530,
	"./core-features/camping_cut_compressed.jpg": 5180,
	"./core-features/charcreator_blur_compressed.jpg": 9481,
	"./core-features/farming_compressed.jpg": 5159,
	"./core-features/nightlife_light_compressed.jpg": 6415,
	"./core-features/police_compressed.jpg": 7369,
	"./hero_elegy_compressed.jpg": 4362,
	"./jobs/backend_compressed.jpg": 8581,
	"./jobs/frontend_compressed.jpg": 6704,
	"./lumina_color_without_decoration.svg": 3850,
	"./lumina_horizontal.svg": 2327,
	"./lumina_roleplay.svg": 3497,
	"./lumina_v.svg": 3514,
	"./lumina_v_color_without_decoration.svg": 330,
	"./lumina_v_white.svg": 187,
	"./lumina_v_white_without_decoration.svg": 6551,
	"./lumina_white.svg": 9528,
	"./lumina_white_without_decoration.svg": 2522,
	"./wave.svg": 2866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;